<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               append-to-body
               @close="relvanceClose"
               @open="handleOpen()"
               width="400px">
      <el-form :model="userForm"
               ref="userForm"
               label-width="100px"
               style="marginTop:16px"
               class="userForm">
        <el-form-item label="分类名称·："
                      prop="category_name">
          <el-input v-model="userForm.category_name"
                    placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="筛选项："
                      prop="category_name">
          <div class="tagChoose">

            <el-tag v-for="(itemTag,index) in chooseSenior"
                    :key="index"
                    closable
                    @close="handleCloseTag(itemTag)"
                    style="marginRight:8px">{{itemTag.value}}</el-tag>
          </div>

          <div class="choose"
               @click="chooseTutor()">请选择</div>

        </el-form-item>
        <el-form-item label="内部备注："
                      prop="senior_inner_remark">
          <el-input v-model="userForm.senior_inner_remark"
                    placeholder="请输入内部备注"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div class="cancle"
             @click="relvanceClose()">取消</div>
        <div class="confirm"
             @click="relvaneChoose()">确定</div>
      </div>
    </el-dialog>

    <el-dialog title="筛选项"
               :close-on-click-modal="false"
               :visible.sync="chooseVisible"
               @close="handletutoClose"
               append-to-body
               width="480px">
      <el-form :model="dataForm"
               ref="userForm"
               label-width="100px"
               class="userForm">
        <el-form-item label="院校："
                      prop="page_college_codes">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in colleges"
                    closable
                    :disable-transitions="false"
                    @close="handleCollegeTypeRemove(item)">
              {{ `${item.name}` }}
            </el-tag>
            <el-button type="text"
                       @click="handleCollegeChoose(2)">选择院校</el-button>
          </div>
        </el-form-item>
        <el-form-item label="专业："
                      prop="majors">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in majors"
                    closable
                    :disable-transitions="false"
                    @close="handleMajorTypeRemove(item)">
              {{ `${item.name}/${item.code}` }}
            </el-tag>
            <el-button type="text"
                       @click="handleMajorChoose(2)">选择专业</el-button>
          </div>
        </el-form-item>
        <el-form-item label="科目："
                      prop="majors">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in subjects"
                    closable
                    :disable-transitions="false"
                    @close="handleSubjecTypeRemove(item)">
              {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                }}
            </el-tag>
            <el-button type="text"
                       @click="handleSubjectChoose(2)">选择科目</el-button>
          </div>
        </el-form-item>
        <el-form-item label="辅导项："
                      style="marginTop:10px">
          <el-select v-model="extra_tutoring_types"
                     clearable
                     placeholder="请选择"
                     style="width: 320px"
                     @click="chooseTutur()">
            <el-option v-for="(item, index) in tutorList"
                       :key="index"
                       :label="item.value"
                       :value="item.id">
              <span>{{
                    item.value
                  }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div class="cancle"
             @click="handleTutorClose()">取消</div>
        <div class="confirm"
             @click="tutorChoose()">确定</div>
      </div>
    </el-dialog>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"></SubjectChoose>
  </div>
</template>

<script>
import {
  categoryDetail,
  themeType,
  seniorCategoryDetail,
  seniorCategoryPut,
} from '@/api/senior'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
import MajorChoose from '@/components/dialog/major/MajorChoose'
export default {
  components: { CollegeChoose, SubjectChoose, MajorChoose },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    concatDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    title: {
      type: String,
      default: () => {
        return '创建分类'
      },
    },
    categorId: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      chooseVisible: false,
      colleges: [],
      majors: [],
      subjects: [],
      collegeChooseDialog: false,
      majorChooseDialog: false,
      subjectChooseDialog: false,
      userForm: { senior_inner_remark: '', category_name: '' },
      dialogVisible: this.visible,
      dataForm: this.concatDetail,
      imgVisible: false,
      dialogImageUrl: '',
      results: [],
      product_type: 1,
      ProductChooseDialog: false,
      pageTotal: 10,
      query: {
        pageIndex: 1,
        pageSize: 10,
      },
      extra_tutoring_types: '',
      tutorList: [
        {
          id: 101,
          value: '政治',
          isFlag: false,
        },
        {
          id: 102,
          value: '英语一',
          isFlag: false,
        },
        {
          id: 103,
          value: '英语二',
          isFlag: false,
        },
        {
          id: 104,
          value: '数学一',
          isFlag: false,
        },
        {
          id: 105,
          value: '数学二',
          isFlag: false,
        },
        {
          id: 106,
          value: '数学三',
          isFlag: false,
        },
        {
          id: 107,
          value: '英语作文批改',
          isFlag: false,
        },
        {
          id: 108,
          value: '199管理类综合',
          isFlag: false,
        },
        {
          id: 109,
          value: '408计算机综合',
          isFlag: false,
        },

        {
          id: 201,
          value: '复试邮件简历',
          isFlag: false,
        },
        {
          id: 202,
          value: '中英文自我介绍',
          isFlag: false,
        },
        {
          id: 203,
          value: '复试口语',
          isFlag: false,
        },
        {
          id: 204,
          value: '综合面试',
          isFlag: false,
        },
        {
          id: 205,
          value: '调剂指导',
          isFlag: false,
        },
        {
          id: 301,
          value: '高等数学',
          isFlag: false,
        },
        {
          id: 302,
          value: '线性代数',
          isFlag: false,
        },
        {
          id: 303,
          value: '概率论与数理统计',
          isFlag: false,
        },
        {
          id: 304,
          value: '大学物理',
          isFlag: false,
        },
        {
          id: 305,
          value: '材料力学',
          isFlag: false,
        },
        {
          id: 306,
          value: '数字电路与模拟电路',
          isFlag: false,
        },
        {
          id: 307,
          value: '理论力学',
          isFlag: false,
        },
        {
          id: 308,
          value: '电工学',
          isFlag: false,
        },
        {
          id: 309,
          value: '运筹学',
          isFlag: false,
        },
        {
          id: 310,
          value: '机械原理',
          isFlag: false,
        },
        {
          id: 311,
          value: '结构力学',
          isFlag: false,
        },
        {
          id: 312,
          value: '自动控制原理',
          isFlag: false,
        },
        {
          id: 313,
          value: '电路',
          isFlag: false,
        },
        {
          id: 401,
          value: '英语四六级',
          isFlag: false,
        },
        {
          id: 402,
          value: '雅思',
          isFlag: false,
        },
        {
          id: 403,
          value: '托福',
          isFlag: false,
        },
        {
          id: 404,
          value: 'GRE',
          isFlag: false,
        },
        {
          id: 405,
          value: '英语专业四级',
          isFlag: false,
        },
        {
          id: 406,
          value: '英语专业八级',
          isFlag: false,
        },
        {
          id: 407,
          value: '计算机二级',
          isFlag: false,
        },
        {
          id: 501,
          value: '教师资格证',
          isFlag: false,
        },
        {
          id: 502,
          value: '法律职业资格（法考）',
          isFlag: false,
        },
        {
          id: 503,
          value: '证券/基金/银行从业资格',
          isFlag: false,
        },
        {
          id: 504,
          value: '初级会计职称',
          isFlag: false,
        },
        {
          id: 505,
          value: '注册会计师（CPA）',
          isFlag: false,
        },
        {
          id: 506,
          value: '导游资格证',
          isFlag: false,
        },
      ],
      chooseSenior: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    concatDetail(val) {
      this.dataForm = val
    },
  },
  methods: {
    handleCloseTag(itemTag) {
      this.chooseSenior = this.chooseSenior.filter((v) => {
        return v.value != itemTag.value
      })
    },
    chooseTutor() {
      this.chooseVisible = true
    },
    relvaneChoose() {
      let collge = []
      let major = []
      let majorName = []
      let subject = []
      let subjectName = []
      let extreCode = []
      this.chooseSenior.map((j, v) => {
        // item.map((j, v) => {
        if (j.type == 'college') {
          collge.push(j.id)
        }

        if (j.type == 'major') {
          major.push(j.id)
          majorName.push(j.value)
        }

        if (j.type == 'subject') {
          subject.push(j.id)
          subjectName.push(j.value)
        }

        if (j.type == '辅导') {
          extreCode.push(j.id)
        }
        // })
      })

      let data = {
        category_name: this.userForm.category_name,
        theme_page_id: this.concatDetail.id,
        senior_college_codes: collge.join(','),
        senior_major_codes: major.join(','),
        senior_major_names: majorName.join(','),
        senior_subject_codes: subject.join(','),
        senior_subject_names: subjectName.join(','),
        senior_tutoring_types: extreCode.join(','),
        senior_inner_remark: this.userForm.senior_inner_remark,
      }
      if (this.title == '创建分类') {
        themeType(data).then((res) => {
          this.$message.success('操作成功')
          this.relvanceClose()
        })
      } else {
        data.id = this.categorId
        seniorCategoryPut(data).then((res) => {
          this.$message.success('修改成功')
          this.relvanceClose()
        })
      }
    },
    relvanceClose() {
      this.userForm = {}
      this.chooseSenior = []
      this.$emit('getList')
    },
    tutorChoose() {
      this.colleges.map((item) => {
        this.chooseSenior.push({
          type: 'college',
          id: item.code,
          value: item.name,
        })
      })
      this.majors.map((item) => {
        this.chooseSenior.push({
          type: 'major',
          id: item.code,
          value: item.name,
        })
      })
      this.subjects.map((item) => {
        this.chooseSenior.push({
          type: 'subject',
          id: item.code,
          value: item.name,
        })
      })
      if (this.extra_tutoring_types != '') {
        let names = null
        this.tutorList.map((item) => {
          if (item.id == this.extra_tutoring_types) {
            names = item.value
          }
        })
        this.chooseSenior.push({
          type: '辅导',
          id: this.extra_tutoring_types,
          value: names,
        })
      }
      this.handleTutorClose()
      this.chooseVisible = false
    },
    handleTutorClose() {
      this.extra_tutoring_types = ''
      this.colleges = []
      this.majors = []
      this.subjects = []
      this.chooseVisible = false
    },
    handleCollegeTypeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },

    handleCollegeChoose(types) {
      this.collegeChooseDialog = true
    },
    handleMajorChoose(types) {
      this.majorChooseDialog = true
    },
    handleSubjectChoose(types) {
      this.subjectChooseDialog = true
    },
    handleOpen() {
      if (this.categorId != null) {
        seniorCategoryDetail({ id: this.categorId }).then((res) => {
          if (res) {
            this.userForm.category_name = res.category_name
            this.userForm.senior_inner_remark = res.senior_inner_remark
            // 筛选项

            if (res.senior_college_codes != '') {
              let tt = null
              this.$store.state.collegeList.map((item) => {
                if (item.code == res.senior_college_codes) {
                  tt = item.name
                }
              })
              this.chooseSenior.push({
                type: 'college',
                id: res.senior_college_codes,
                value: tt,
              })
            }
            if (res.senior_major_codes != '') {
              this.chooseSenior.push({
                type: 'major',
                id: res.senior_major_codes,
                value: res.senior_major_names,
              })
            }

            if (res.senior_subject_codes != '') {
              this.chooseSenior.push({
                type: 'subject',
                id: res.senior_subject_codes,
                value: res.senior_subject_names,
              })
            }
            if (res.senior_tutoring_types != '') {
              let names = null
              this.tutorList.map((item) => {
                if (item.id == res.senior_tutoring_types) {
                  names = item.value
                }
              })

              this.chooseSenior.push({
                type: '辅导',
                id: res.senior_tutoring_types,
                value: names,
              })
            }
          }
        })
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    handletutoClose() {
      this.chooseVisible = false
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
    },
  },
}
</script>

<style lang="less" scoped>
.create {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.footer {
  display: flex;
  justify-content: flex-end;
  .cancle {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #909399;
    width: 56px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdfe6;
    margin-right: 16px;
  }
  .confirm {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    width: 56px;
    height: 36px;
    line-height: 36px;
    background: #409eff;
    border-radius: 4px 4px 4px 4px;
  }
}
.dialog-wrap {
}
/deep/.el-upload {
  width: 122px;
  height: 122px;
  line-height: 122px;
}
/deep/.el-upload-list__item {
  width: 122px;
  height: 122px;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
.choose {
  font-size: 12px;
  color: #409eff;
}
.tagChoose {
  display: flex;
  margin-right: 10px;
  flex-wrap: wrap;
}
</style>
